import { ReactNode } from 'react';

import { cn } from '@/lib/utils';
import { ResponseMessage } from '@/shared/types/tryIt';

import { bubbleBrainClasses, responseClasses } from './constants';

type UrlMessage = Extract<ResponseMessage, { type: 'url' }>;

interface UrlResponseProps {
  response: UrlMessage;
  icon: ReactNode;
  goToButton: ReactNode;
  turnRow?: boolean;
}

export const UrlResponse = ({ response, icon, goToButton, turnRow = false }: UrlResponseProps) => {
  return (
    <div className={responseClasses}>
      {icon}
      <p className={bubbleBrainClasses}>
        <a
          href={response.url}
          target="_blank"
          rel="noopener noreferrer"
          className={cn(
            'flex items-center',
            turnRow ? 'text-sm leading-5 font-normal text-primary' : 'text-primary'
          )}
        >
          {response.url}
        </a>
      </p>
      {goToButton}
    </div>
  );
};
